import React from 'react';

const EmptyState = ({ 
  icon, 
  title, 
  description, 
  actionButton,
  variant = 'default' // 'default', 'no-data', 'no-connection'
}) => {
  // Default icons for different empty state types
  const defaultIcons = {
    'no-data': (
      <svg 
        width="80" 
        height="80" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="1" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        className="text-grey-60"
      >
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
        <polyline points="14,2 14,8 20,8"></polyline>
        <line x1="16" y1="13" x2="8" y2="13"></line>
        <line x1="16" y1="17" x2="8" y2="17"></line>
        <polyline points="10,9 9,9 8,9"></polyline>
      </svg>
    ),
    'no-connection': (
      <svg 
        width="80" 
        height="80" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="1" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        className="text-grey-60"
      >
        <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
        <polyline points="9,22 9,12 15,12 15,22"></polyline>
        <path d="m9 10 3-3 3 3"></path>
      </svg>
    ),
    'sync': (
      <svg 
        width="80" 
        height="80" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="1" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        className="text-grey-60"
      >
        <path d="M4 4v5h.582m15.356 2A8.001 8.001 0 0 0 4.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 0 1-15.357-2m15.357 2H15"></path>
      </svg>
    ),
    'search': (
      <svg 
        width="80" 
        height="80" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="1" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        className="text-grey-60"
      >
        <circle cx="11" cy="11" r="8"></circle>
        <path d="m21 21-4.35-4.35"></path>
      </svg>
    )
  };

  const iconToShow = icon || defaultIcons[variant] || defaultIcons['no-data'];

  return (
    <div className="flex items-center justify-center py-16 px-6">
      <div className="text-center max-w-md">
        {/* Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 flex items-center justify-center bg-grey-10 rounded-full">
            {iconToShow}
          </div>
        </div>
        
        {/* Title */}
        <h3 className="text-lg font-medium text-black-0 mb-3">
          {title}
        </h3>
        
        {/* Description */}
        <p className="text-sm text-grey-60 leading-relaxed mb-6">
          {description}
        </p>
        
        {/* Action Button */}
        {actionButton && (
          <div className="flex justify-center">
            {actionButton}
          </div>
        )}
      </div>
    </div>
  );
};

export default EmptyState; 